module.exports = __webpack_public_path__ + "media/images/contact_now-3ef9c053.svg";